import React, { useState } from 'react';
import { Check, X, ArrowRight, Clock, Target, Shield, BarChart3, Users, Layers, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';
import { CampaignSelector } from '../components/CampaignSelector';
const fmt = (n: number) => n.toLocaleString('en-US');
export function AdvantageProduct() {
  const [campaignMode, setCampaignMode] = useState(1);
  const isPartial = campaignMode === 0;
  const campaigns = isPartial ? 1 : campaignMode;
  const buildFee = isPartial ? 6500 : 6500 + 1000 * (campaignMode - 1);
  const systemFee = 2500;
  const campaignFee = isPartial ? 1250 : 2500 * campaigns;
  const monthlyTotal = systemFee + campaignFee;
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans" data-id="element-460" data-mp="2aqnf0b1sllq">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-8 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-461" data-mp="1hqpe0xomfyy8">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-462" data-mp="1dpnesgupfmw9" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-463" data-mp="2xovy2i6xlaq4">
          <div className="inline-block px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-6" data-id="element-464" data-mp="3bl9gbtjahg5n">
            Flagship Partnership
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-465" data-mp="2iy6k58235hik">
            HIRE Advantage
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto leading-relaxed" data-id="element-466" data-mp="2nuwy9puby31c">
            HIRE Advantage is the partnership where recruiting becomes
            consistent, predictable, and scalable.
          </p>
        </motion.div>
      </section>

      {/* 2. PRICING */}
      <section className="pt-4 pb-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-467" data-mp="2052rnq0ltapj">
        <CampaignSelector mode={campaignMode} onChange={setCampaignMode} accent="mint" data-id="element-468" data-mp="33gi5t4nl4p26" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-469" data-mp="2yh5kiocd3q1p">
          {/* Build Fee */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-470" data-mp="3cchcinz4v2ex">
            <div className="mb-4" data-id="element-471" data-mp="38b5mihcckf67">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-472" data-mp="2kifbcac9pzwz">
                Build and Implementation (One-Time)
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-473" data-mp="2fmgst3dmfc4h">
                ${fmt(buildFee)}
              </div>
              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-474" data-mp="2oksgoxn3rvt8">
                {['Company and opportunity profiling', 'Custom ATS with dashboards, workflows, and job board integrations', 'Culture video and ad copywriting', 'Landing pages and candidate application flows', 'Full funnel design, from ad to onboarding', 'Compensation and role benchmarking by region', 'Pre-launch system stress test', 'Team training and 90-day coaching to optimize output'].map((point, i) => <li key={i} className="flex items-start" data-id="element-475" data-mp="7d0t0ted2prf" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-476" data-mp="v1juaoyzu2a0" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-477" data-mp="100wm7o4q1zjg">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Monthly Total */}
          <div className="bg-slate-900/40 border border-[#7FE0C3]/30 p-6 rounded-xl relative" data-id="element-478" data-mp="q9ikrat7mpno">
            <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3] rounded-t-xl" data-id="element-479" data-mp="1dzmm1bixedbi" />
            <div className="mb-4" data-id="element-480" data-mp="1it8q4fb0x8vp">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-2" data-id="element-481" data-mp="1ith09zfri037">
                Total Monthly
              </div>
              <div className="text-4xl font-bold text-white mb-1" data-id="element-482" data-mp="3m9dwmyv3yt5n">
                ${fmt(monthlyTotal)}
              </div>
              <div className="text-sm text-slate-500 mb-6" data-id="element-483" data-mp="3hb2oqtodisq2">/ month</div>

              <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-484" data-mp="3cc9b919371pw">
                <div className="flex justify-between text-sm" data-id="element-485" data-mp="dtkj8sw2pxst">
                  <span className="text-slate-400" data-id="element-486" data-mp="dt123ee8zdfu">System Fee</span>
                  <span className="text-white font-medium" data-id="element-487" data-mp="8vsg12pzap9b">
                    ${fmt(systemFee)}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-488" data-mp="41o5yalf2140">
                  <span className="text-slate-400" data-id="element-489" data-mp="3v9iv2jibqh7o">
                    {isPartial ? 'Partial Campaign' : campaigns === 1 ? 'Campaign Management' : `Campaign Management (x${campaigns})`}
                  </span>
                  <span className="text-white font-medium" data-id="element-490" data-mp="z6ay530fl8ow">
                    ${fmt(campaignFee)}
                  </span>
                </div>
              </div>

              <ul className="mt-5 space-y-2 pt-4 border-t border-slate-800/50" data-id="element-491" data-mp="192e98yd9ghnz">
                {['Active ad management and real-time optimization', 'Live applicant screening, 14 hrs/day, 7 days/week', 'Interview auditing and coaching to improve retention', 'Monthly recruiting review and ongoing consulting'].map((point, i) => <li key={i} className="flex items-start" data-id="element-492" data-mp="1ruqafhs6hcwj" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-493" data-mp="1ws8mvi5ema9a" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-494" data-mp="21rlbo8fu5rei">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-495" data-mp="6nn8emnwfj9k">
            <div className="mb-4" data-id="element-496" data-mp="1plra7a19u0q">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-4" data-id="element-497" data-mp="1qn168fbcagv">
                Sales School Tickets
              </div>
              <div className="flex items-baseline mb-2" data-id="element-498" data-mp="fil6s99tfo8a">
                <span className="text-3xl font-bold text-white" data-id="element-499" data-mp="ap8hry185ff0">$200</span>
                <span className="text-slate-400 ml-2 text-sm" data-id="element-500" data-mp="pe4yskl9e2rr">per ticket</span>
              </div>
              <p className="mt-5 pt-4 border-t border-slate-800/50 text-slate-400 text-sm leading-snug" data-id="element-501" data-mp="kgmmqlby37fj">
                Sales School tickets are purchased separately based on the number
                of attendees.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-502" data-mp="306pmejd9f2ws">
          <p className="text-[#7FE0C3] text-center font-medium" data-id="element-503" data-mp="2w5vz9s7n5s4y">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </section>

      {/* 2. PROBLEM REFRAME */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto border-t border-slate-800/50" data-id="element-504" data-mp="2q2j1zt3lgl62">
        <div className="text-center mb-12" data-id="element-505" data-mp="2cb4f3b6kfztq">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-506" data-mp="2hah2bx1cn8wu">
            The Real Problem
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-507" data-mp="22dpz1cok1d1y">
            Most companies don't fail at finding candidates. They fail at system
            execution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-508" data-mp="27a6r2hyvkbkb">
          <div className="bg-slate-900/30 border border-slate-800 p-8 rounded-xl" data-id="element-509" data-mp="1tecqqnc62uit">
            <h3 className="text-sm text-rose-400 uppercase tracking-widest font-bold mb-6" data-id="element-510" data-mp="1ycnymsiwiuye">
              System Failures
            </h3>
            <ul className="space-y-4" data-id="element-511" data-mp="3noyhipcgn8qz">
              {['Inconsistent interviews', 'Drifting hiring standards', 'Early churn discovered too late', 'Leaders relying on gut decisions'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-512" data-mp="106m5zhsxn84l" data-mpi={idx}>
                  <X className="w-5 h-5 text-rose-500/50 mr-3 mt-0.5 flex-shrink-0" data-id="element-513" data-mp="vdt36zh0y9v5" />
                  <span className="line-through opacity-70" data-id="element-514" data-mp="rchc0pii5gku">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="flex flex-col justify-center p-8" data-id="element-515" data-mp="mccrmoeh41pc">
            <p className="text-xl text-white font-medium mb-4" data-id="element-516" data-mp="heb862d4y0dc">
              Advantage solves the system failure, not just the talent shortage.
            </p>
            <p className="text-slate-400" data-id="element-517" data-mp="8eoanrnj1epk">
              We replace guesswork with infrastructure and accountability.
            </p>
          </div>
        </div>
      </section>

      {/* 3. WHAT ADVANTAGE IS */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-518" data-mp="22s5zdhzo4hm6">
        <div className="max-w-5xl mx-auto" data-id="element-519" data-mp="3kqkdw4q2rmxl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-520" data-mp="3kpsv5uhktjoq">
            <div data-id="element-521" data-mp="3podkuzz7ckyx">
              <h2 className="text-3xl font-bold text-white mb-6" data-id="element-522" data-mp="3pnucoazctay3">
                Full System Ownership
              </h2>
              <div className="space-y-4 text-slate-400 mb-8" data-id="element-523" data-mp="3ui8asl5ehw6g">
                <p data-id="element-524" data-mp="2b1grm3xj2c0">This is not lead generation.</p>
                <p data-id="element-525" data-mp="31rg9585kgfbq">This is not outsourced recruiting.</p>
                <p data-id="element-526" data-mp="31t13awnyxw92">This is full ownership of the recruiting system.</p>
              </div>
              <div className="p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg" data-id="element-527" data-mp="36rcdj8i6e8rt">
                <p className="text-[#7FE0C3] font-medium" data-id="element-528" data-mp="3ar3ajtyapl4s">
                  HIRE Advantage is the only partnership level where HIRE is
                  accountable for the recruiting system actually working.
                </p>
              </div>
            </div>
            <div className="space-y-6" data-id="element-529" data-mp="v10dm3od83r8">
              <div className="flex items-start" data-id="element-530" data-mp="uzp7vybd0lxh">
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-531" data-mp="2ibh2cg4ihyxe">
                  <Shield className="w-6 h-6 text-[#7FE0C3]" data-id="element-532" data-mp="2n994s42s93fu" />
                </div>
                <div data-id="element-533" data-mp="2s10mdp3ynytu">
                  <h3 className="text-white font-bold mb-2" data-id="element-534" data-mp="2s2livk9u5ruc">Accountability</h3>
                  <p className="text-slate-400 text-sm" data-id="element-535" data-mp="2x0n1y579hr5t">
                    We don't just deliver leads; we own the outcome of the
                    system's performance.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-536" data-mp="24by5ijh5ia0e">
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-537" data-mp="29a9fqvbcymj5">
                  <Target className="w-6 h-6 text-[#7FE0C3]" data-id="element-538" data-mp="2ddpcrsrcaowd" />
                </div>
                <div data-id="element-539" data-mp="3kpeke4v1uv5e">
                  <h3 className="text-white font-bold mb-2" data-id="element-540" data-mp="3ks0plxugwykg">Consistency</h3>
                  <p className="text-slate-400 text-sm" data-id="element-541" data-mp="3opygd53vzspy">
                    Eliminating the variance between good weeks and bad weeks.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. 10-STEP SYSTEM */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-542" data-mp="14akyt85zcew7">
        <div className="text-center mb-12" data-id="element-543" data-mp="zdb1l6ccmyxt">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-544" data-mp="zc9net01dwbv">
            The 10-Step Recruiting System
          </h2>
          <p className="text-slate-400" data-id="element-545" data-mp="ublo7k1nm96k">
            Every HIRE Advantage partner runs the same system. The difference is
            who owns it.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-546" data-mp="ldjr3fl1k0ok">
          {['Attract', 'Engage', 'Screen', 'Qualify', 'Commit', 'Schedule', 'Launch', 'Integrate', 'Train', 'Retain'].map((step, idx) => <div key={idx} className="bg-slate-900/40 border border-slate-800 p-6 rounded-lg text-center hover:border-[#7FE0C3]/30 transition-colors group" data-id="element-547" data-mp="2twl0lqr68wbf" data-mpi={idx}>
              <div className="text-xs text-slate-500 mb-2 font-mono" data-id="element-548" data-mp="2kvv9h0cuvu41">
                0{idx + 1}
              </div>
              <div className="text-white font-medium group-hover:text-[#7FE0C3] transition-colors" data-id="element-549" data-mp="2pug9ayo74bry">
                {step}
              </div>
            </div>)}
        </div>
      </section>

      {/* 5. OWNERSHIP MAP */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-550" data-mp="3hkujajt393yc">
        <div className="max-w-6xl mx-auto" data-id="element-551" data-mp="33lbcbuc0jynm">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-552" data-mp="33oqqmuxv53nz">
            Ownership Map
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-553" data-mp="1s7h94dyaolpb">
            {/* HIRE Owns */}
            <div className="bg-slate-900/40 border border-[#7FE0C3]/20 rounded-xl p-8 relative overflow-hidden" data-id="element-554" data-mp="1x60ti9x8ppfk">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3]" data-id="element-555" data-mp="1pm03qd3pjzkt" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-556" data-mp="1knyj3nqmvs78">
                <span className="w-2 h-2 rounded-full bg-[#7FE0C3] mr-3" data-id="element-557" data-mp="1kq1b2dbcjvel" />
                HIRE Owns
              </h3>
              <ul className="space-y-4" data-id="element-558" data-mp="1tomppxdp6qa3">
                {['Recruiting system architecture (custom ATS)', 'Traffic, screening, and qualification standards', 'Hiring consistency and interview structure', 'Sales School and launch readiness', 'Early performance tracking and correction', 'Ongoing optimization and accountability'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-559" data-mp="1aw2c1n6kkrqv" data-mpi={idx}>
                    <Check className="w-5 h-5 text-[#7FE0C3] mr-3 mt-0.5 flex-shrink-0" data-id="element-560" data-mp="n6hrizurpmfh" />
                    <span data-id="element-561" data-mp="i8oh1umfm69e">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* You Own */}
            <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 relative overflow-hidden" data-id="element-562" data-mp="10urt034ocwzo">
              <div className="absolute top-0 left-0 w-full h-1 bg-slate-600" data-id="element-563" data-mp="15tkusyalmzk0" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-564" data-mp="1akulm27vw8xh">
                <span className="w-2 h-2 rounded-full bg-slate-600 mr-3" data-id="element-565" data-mp="1amxgp0nw8s92" />
                You Own
              </h3>
              <ul className="space-y-4" data-id="element-566" data-mp="1jlixordpvz7q">
                {['Final hiring decisions', 'Day-to-day sales leadership', 'Culture and performance expectations'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-567" data-mp="1tj6tzlqz1es0" data-mpi={idx}>
                    <div className="w-5 h-5 rounded-full bg-slate-800 border border-slate-700 mr-3 mt-0.5 flex-shrink-0 flex items-center justify-center" data-id="element-568" data-mp="3qd0knaw8r9w4">
                      <div className="w-1.5 h-1.5 rounded-full bg-slate-500" data-id="element-569" data-mp="3vcwnh6t7cva3" />
                    </div>
                    <span data-id="element-570" data-mp="27p8syi7kw6eg">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 6. TIMELINE */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-571" data-mp="23lj9g75rgf0a">
        <h2 className="text-3xl font-bold text-white mb-16 text-center" data-id="element-572" data-mp="1ypu2hirevvty">
          Partnership Timeline
        </h2>

        <div className="relative" data-id="element-573" data-mp="2ve0e4pmr3ohq">
          {/* Horizontal connector line (desktop only) */}
          <div className="hidden md:block absolute top-3 left-[16.66%] right-[16.66%] h-px bg-gradient-to-r from-transparent via-[#7FE0C3]/30 to-transparent" data-id="element-574" data-mp="2rdzpyd9unyxh" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-575" data-mp="2hftq017lt2v9">
            {[{
            days: 'Days 1–21',
            title: 'Build & Launch',
            items: ['System architecture build', 'Campaign launch', 'Sales School setup', 'First candidates generated']
          }, {
            days: 'Weeks 4–12',
            title: 'Support & Consulting',
            items: ['Weekly support and consulting', 'Establishing strong baseline KPIs', 'Interviewing 30+ triple screened prospects/mo', 'Hiring 15+ people/mo']
          }, {
            days: 'Month 3+',
            title: 'Optimization',
            items: ['Increase conversion rates', 'Improve retention', 'Maximize ROI', 'Scale successful patterns']
          }].map((phase, idx) => <div key={idx} className="flex flex-col items-center" data-id="element-576" data-mp="5sgnzkolqz6q" data-mpi={idx}>
                {/* Timeline dot */}
                <div className="hidden md:flex items-center justify-center w-6 h-6 rounded-full bg-[#0A0F1C] border-2 border-[#7FE0C3] z-10 mb-8" data-id="element-577" data-mp="asumab0eiurk">
                  <div className="w-2 h-2 rounded-full bg-[#7FE0C3]" data-id="element-578" data-mp="3ic2qpib3jst9" />
                </div>

                <div className="w-full bg-slate-900/30 border border-slate-800 p-6 rounded-xl text-center md:text-left" data-id="element-579" data-mp="13fpgqijupqy">
                  <div className="text-[#7FE0C3] font-bold text-sm uppercase tracking-widest mb-2" data-id="element-580" data-mp="3s8nuk0bdqxvi">
                    {phase.days}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-581" data-mp="550x9xg88dua">
                    {phase.title}
                  </h3>
                  <ul className="space-y-2" data-id="element-582" data-mp="jtx63wq3xuvy">
                    {phase.items.map((item, i) => <li key={i} className="text-slate-400 text-sm flex items-start justify-center md:justify-start" data-id="element-583" data-mp="euashm6dacmm" data-mpi={i}>
                        <span className="w-1.5 h-1.5 rounded-full bg-slate-700 mr-2 mt-1.5 flex-shrink-0" data-id="element-584" data-mp="otjftw6q8t00" />
                        <span data-id="element-585" data-mp="1v6mvh8t6iark">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. WHO THIS IS FOR */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-586" data-mp="253rj7d2oaeah">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-587" data-mp="29664e3ttdq4x">
          <div data-id="element-588" data-mp="1chqcw27596p6">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-589" data-mp="1chzv33ly69kb">
              <Check className="w-5 h-5 text-[#7FE0C3] mr-2" data-id="element-590" data-mp="1hfrusjsu2zz2" />
              This is for teams who:
            </h3>
            <ul className="space-y-4" data-id="element-591" data-mp="1lhmy1tubrnfh">
              {['Want recruiting to actually work', 'Value consistency over heroics', 'Are open to better systems', 'Want a partner, not a vendor'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-592" data-mp="xris3ftnzblb" data-mpi={idx}>
                  <span className="w-1.5 h-1.5 rounded-full bg-[#7FE0C3] mr-3 mt-2" data-id="element-593" data-mp="q8t45da0ojf1" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-594" data-mp="l7lqwyp3us0z">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-595" data-mp="h836e4174iyo">
              <X className="w-5 h-5 text-rose-500 mr-2" data-id="element-596" data-mp="ha7j9bh2osb3" />
              This is not for teams who:
            </h3>
            <ul className="space-y-4" data-id="element-597" data-mp="79x95zqc4105">
              {['Only want resumes', "Aren't open to process", 'Want zero accountability'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-598" data-mp="3tp069fcsa8lp" data-mpi={idx}>
                  <span className="w-1.5 h-1.5 rounded-full bg-rose-500 mr-3 mt-2" data-id="element-599" data-mp="3pnwpmqmww8jf" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* 9. HOW THIS SCALES */}
      <section className="py-16 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800 text-center" data-id="element-600" data-mp="3fqs0qj1olyyx">
        <div className="max-w-3xl mx-auto" data-id="element-601" data-mp="3egci34z2n4mi">
          <h2 className="text-2xl font-bold text-white mb-8" data-id="element-602" data-mp="3ef1dx41pruuv">
            How This Scales
          </h2>
          <div className="flex flex-col md:flex-row justify-center gap-6 text-left" data-id="element-603" data-mp="39gge35qdjd6y">
            <div className="flex-1 p-6 border border-[#7FE0C3]/30 rounded-lg bg-slate-800/30" data-id="element-604" data-mp="34laqm2hbpqgr">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-2" data-id="element-605" data-mp="2zm7lyj599m9b">
                Foundation
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-606" data-mp="2qs2y88lf4qy0">Advantage</h3>
              <p className="text-slate-400 text-sm" data-id="element-607" data-mp="2qpq99bh8tgbg">
                The foundation your recruiting runs on.
              </p>
            </div>
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-608" data-mp="2guersleg9v00">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-609" data-mp="2bv24jzjo2lww">
                Execution
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-610" data-mp="27u8lpkl2zxav">Summit</h3>
              <p className="text-slate-400 text-sm" data-id="element-611" data-mp="nbfvs1fasan0">
                Exists when execution capacity is the bottleneck.
              </p>
            </div>
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-612" data-mp="rekwbyfti290">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-613" data-mp="wcdzeiltqg52">
                Leadership
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-614" data-mp="3mx9pspl9dcj">Leadership</h3>
              <p className="text-slate-400 text-sm" data-id="element-615" data-mp="3kucooq0qjyb">
                Add it when finding leadership becomes the bottleneck.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 10. CTA */}
      <section className="py-32 px-6 md:px-12 text-center" data-id="element-616" data-mp="ibti5qvk4sdo">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-617" data-mp="ideffo99apf8">
          Ready to make recruiting predictable?
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-[#7FE0C3] hover:bg-[#5ACCA8] text-[#163A5F] font-bold rounded-lg transition-all transform hover:scale-105" data-id="element-618" data-mp="3m0wugvt7871m">
          Let's see if Advantage is the right fit
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-619" data-mp="39z56rt7xkgxy" />
        </button>
      </section>
    </div>;
}